import React from "react";
import DateIcon from "./DateIcon";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

function Festival(props) {
  return (
    <Link className="linked-list-item" to={`/festival/${props.id}`}>
      <div className="list-item">
        <div className="date-wrapper">
          <DateIcon date={props.start_date} />
        </div>
        {props.end_date !== "" ? "to" : ""}
        <div className="date-wrapper">
          <DateIcon date={props.end_date} />
        </div>
        <div className="eventDetails">
          <div
            className="list-item-title"
            dangerouslySetInnerHTML={{ __html: props.title }}
          ></div>
          <div className="item-date">
            {new Intl.DateTimeFormat("en-GB", {
              year: "numeric",
              month: "short",
              day: "2-digit",
              weekday: "short"
            }).format(
              new Date(
                props.start_date.substr(0, 4) +
                  "-" +
                  props.start_date.substr(4, 2) +
                  "-" +
                  props.start_date.substr(6, 2)
              )
            )}
          </div>
        </div>
        <div className="next-indicator">
          <FontAwesomeIcon icon={faChevronRight} />
        </div>
      </div>
    </Link>
  );
}

export default Festival;
